import {
  FONT_BASE,
  FONT_DISPLAY,
  FONT_MAX,
  FONT_WEIGHT_MEDIUM,
  LINE_HEIGHT_HEADING,
} from '../themeConstants'

const heading = (size) => ({
  fontFamily: 'var(--app-font-sans)',
  fontSize: size,
  fontWeight: FONT_WEIGHT_MEDIUM,
  lineHeight: LINE_HEIGHT_HEADING,
  letterSpacing: 0,
})

export const typographyHeadings = {
  h1: heading(FONT_DISPLAY),
  h2: heading(FONT_MAX),
  h3: heading(FONT_MAX),
  h4: heading(FONT_MAX),
  h5: heading(FONT_BASE),
  h6: heading(FONT_BASE),
}
